export type RecipientType =
  | 'adult_male'
  | 'adult_female'
  | 'child_5_under'
  | 'child_6_over'
  | 'pet_cat'
  | 'pet_dog'
  | 'foodbank'

export type PickupLocation = 'school' | 'fayre'

export type YearGroup =
  | 'reception'
  | 'year_1'
  | 'year_2'
  | 'year_3'
  | 'year_4'
  | 'year_5'
  | 'year_6'

export type OrderStatus = 'draft' | 'pending_payment' | 'completed' | 'failed' | 'cancelled'

export interface Gift {
  id: string
  orderId: string
  pickupLocation: PickupLocation
  recipientType: RecipientType
  recipientName: string
  fromName: string
  yearGroup: YearGroup
  price: number
  isPicked: boolean
  pickedAt: string | null
  createdAt: string
}

export interface TimeSlot {
  id: string
  time: string
  slotNumber: number
  isBooked: boolean
  lockedUntil: string | null
  lockedByOrderId: string | null
  status: 'available' | 'locked' | 'pending_payment' | 'booked'
}

export interface SantaBooking {
  id: string
  orderId: string
  timeSlotId: string
  childrenNames: string // JSON string - parse with JSON.parse()
  dietaryRequirements: string
  createdAt: string
  timeSlot?: TimeSlot
}

export interface Order {
  id: string
  orderNumber: number | null
  email: string
  fullName: string
  wantsGifts: boolean
  wantsSanta: boolean
  tokenQuantity: number
  status: OrderStatus
  totalAmount: number
  paymentId: string | null
  receiptId: string | null
  notes: string | null
  createdAt: string
  updatedAt: string
  gifts?: Gift[]
  santaBooking?: SantaBooking
}

export const RECIPIENT_TYPE_LABELS: Record<RecipientType, string> = {
  adult_male: 'Adult Male',
  adult_female: 'Adult Female',
  child_5_under: 'Child (5 and under)',
  child_6_over: 'Child (6 and over)',
  pet_cat: 'Pet Cat',
  pet_dog: 'Pet Dog',
  foodbank: 'Foodbank Donation',
}

export const YEAR_GROUP_LABELS: Record<YearGroup, string> = {
  reception: 'Reception',
  year_1: 'Year 1',
  year_2: 'Year 2',
  year_3: 'Year 3',
  year_4: 'Year 4',
  year_5: 'Year 5',
  year_6: 'Year 6',
}
